/**
 *  Campaigns getters module file
**/

export const getters = {
}
